import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_URL || `${window.location.origin}/api`;
const baseUrl = rawBaseUrl.endsWith("/api") ? rawBaseUrl : `${rawBaseUrl.replace(/\/$/, "")}/api`;

function normalizeProject(p) {
  if (!p) return null;
  const get = (a, b) => (a !== undefined ? a : b);

  return {
    id: get(p.id, get(p.Id, get(p.projectId, p.ProjectId))),
    slug: get(p.slug, p.Slug),
    title: get(p.title, p.Title),
    summary: get(p.summary, p.Summary),
    content: get(p.content, p.Content) || [],
    image: get(p.image, p.Image),
    beforeImages: get(p.beforeImages, p.BeforeImages) || [],
    afterImages: get(p.afterImages, p.AfterImages) || [],
    gallery: get(p.gallery, p.Gallery) || [],
    videos: get(p.videos, p.Videos) || [],
    beforeVideos: get(p.beforeVideos, p.BeforeVideos) || [],
    afterVideos: get(p.afterVideos, p.AfterVideos) || [],
    date: get(p.date, p.Date) || " ",
    status: get(p.status, p.Status),
    tags: get(p.tags, p.Tags) || [],
    category: get(p.category, p.Category) || "genel",
    guid: get(p.guid, p.Guid),
    ...p,
  };
}

export async function getAllProjects(category = "genel") {
  try {
    const res = await axios.get(`${baseUrl}/Project/All`, { params: { category } });
    const payload = res.data;

    if (payload?.isSuccess && Array.isArray(payload.data)) {
      return { isSuccess: true, data: payload.data.map(normalizeProject) };
    }
    if (Array.isArray(payload)) {
      return { isSuccess: true, data: payload.map(normalizeProject) };
    }
    return { isSuccess: false, resultMessage: "Beklenmeyen cevap." };
  } catch (err) {
    console.error("Projects/All error", err);
    return { isSuccess: false, resultMessage: err?.message || "Hata" };
  }
}

// SAYFALI LİSTE
export async function getActiveProjects(pageNum = 1, pageSize = 6, searchTerm = "", category = "genel") {
  try {
    const res = await axios.post(`${baseUrl}/Project/GetActiveProjects`, {
      pageNum: String(pageNum),
      pageSize: String(pageSize),
      searchTerm,
      category,
    });
    const payload = res.data;

    if (payload?.isSuccess && payload?.data) {
      const items = payload.data.items || payload.data.Items || [];
      return {
        isSuccess: true,
        data: { ...payload.data, items: items.map(normalizeProject) },
      };
    }
    return { isSuccess: false, resultMessage: "Beklenmeyen cevap." };
  } catch (err) {
    console.error("GetActiveProjects error", err);
    return { isSuccess: false, resultMessage: err?.message || "Hata" };
  }
}

export function getIskoopProjects(pageNum = 1, pageSize = 6, searchTerm = "") {
  return getActiveProjects(pageNum, pageSize, searchTerm, "iskoop");
}

// Detay (slug ile) – All çağrısı üzerinden bulur
export async function getProjectBySlug(slug) {
  try {
    let r1 = await getAllProjects("genel");
    let list = r1?.data || [];
    let found = list.find((p) => p.slug === slug);

    if (!found) {
      let r2 = await getAllProjects("iskoop");
      let list2 = r2?.data || [];
      found = list2.find((p) => p.slug === slug);
    }

    if (!found) return { isSuccess: false, resultMessage: "Proje bulunamadı" };
    return { isSuccess: true, data: found };
  } catch (err) {
    console.error("getProjectBySlug error", err);
    return { isSuccess: false, resultMessage: err?.message || "Hata" };
  }
}
